import styled from "styled-components";

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 12px;
  margin-top: 16px;
`;

export const TypeCard = styled.button`
  min-height: 84px;
  border-radius: 10px;
  border: 1px solid ${({ disabled }) => (disabled ? "#d9e2ec" : "#d9e2ec")};
  background: ${({ disabled }) => (disabled ? "#f3f5f7" : "#ffffff")};
  padding: 14px;
  text-align: left;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  opacity: ${({ disabled }) => (disabled ? 0.65 : 1)};

  :hover {
    border-color: ${({ disabled }) => (disabled ? "#d9e2ec" : "#0073ab")};
    box-shadow: ${({ disabled }) =>
      disabled ? "none" : "0 8px 18px rgba(0, 115, 171, 0.12)"};
  }
`;

export const TypeTitle = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: #1a1a1a;
`;

export const TypeValue = styled.span`
  font-size: 12px;
  color: #707070;
`;

export const TypeHint = styled.span`
  font-size: 11px;
  color: #707070;
  margin-top: 8px;
`;
